module.exports = __webpack_public_path__ + "images/imagequick3.d571b99f.png";